import React from 'react';

// import YouCanBookMe component
// import YouCanBookMe from '../YouCanBookMe';

// import styled components
import {
  // HeaderButton,
  HeaderContact,
  HeaderContent,
  HeaderWrapper,
  SkipToContentLink,
} from './styled';

// import svg
import OthlLogo from '../../svgs/othl-logo.svg';
import PhoneIcon from '../../svgs/phone-icon.svg';

const Header = ({ toggleModal }) => (
  <HeaderWrapper>
    <SkipToContentLink href="#form">Skip to Main Content</SkipToContentLink>
    <HeaderContent>
      <a
        href="https://onetrusthomeloans.com"
        target="_blank"
        rel="noopener noreferrer"
        title="OneTrust Home Loans"
      >
        <OthlLogo className="logo" />
      </a>
      <HeaderContact>
        {/* <HeaderButton
          onClick={() =>
            toggleModal(
              <YouCanBookMe
                id="ycbmiframemortgage-consultation-website"
                src="https://mortgage-consultation-website.youcanbook.me/?noframe=true&skipHeaderFooter=true"
              />
            )
          }
        >
          Book Consultation Appointment
        </HeaderButton> */}
        <a href="tel:855-995-3323">
          <PhoneIcon />
          (855) 995-3323
        </a>
      </HeaderContact>
    </HeaderContent>
  </HeaderWrapper>
);

export default Header;
